import {TemplateList} from "~/libs/constants/TemplateList"
import {RedactionConfig} from "~/config/RedactionConfig"
export const useRedactionConfig = () => {
  const getAuthorList = () => {
    type TemplateListKeys = keyof typeof TemplateList;
    const uniWebTemplateName:TemplateListKeys | undefined = useRuntimeConfig().public.uniWebTemplateName ? String(useRuntimeConfig().public.uniWebTemplateName).toUpperCase() as TemplateListKeys : undefined
    if (uniWebTemplateName && (uniWebTemplateName in TemplateList)) {
      const authorList = RedactionConfig[TemplateList[uniWebTemplateName]]
      return authorList
    }
    return []
  }


  const getAuthorById = (id: string) => {
    const authorList = getAuthorList()
    return authorList.find(author => author.id === id)
  }

  return {
    getAuthorList,
    getAuthorById
  }
}


